import type { Theme } from "@mui/material"
import { GlobalNavigationItemTheme } from "core/themes/src/definitions/components.types"

export const createGlobalNavigationItemTheme = (theme: Theme): GlobalNavigationItemTheme => ({
    defaultProps: {
        noOffsetOnActive: true,
    },
    styleOverrides: {
        root: {
            borderBottom: "3px solid transparent",
            height: 64,
            color: theme.overwrites?.components?.button?.primary?.fontColor,
            svg: {
                opacity: 1,
            },
            img: {
                opacity: 1,
            },
            "&:hover, &.active": {
                background: 0,
                borderBottomColor: theme.palette.highlight.main,
            },
            "&.active": {
                color: theme.overwrites?.components?.button?.primary?.fontColor,
            },
        },
    },
})
